'use strict';
var walletEpoch = 0;
var sending = false;
var pendingBroadcast = null;
var balancePending = null;
var balanceRequest = null;
var preparedPayment = null;
var preparingPayment = false;
var latestSnapshot = null;
var automaticFeeValue = '';
const balancePrivacyKey = 'minto.wallet.hide-balances.v1';
var balancesHidden = readBalancePrivacy();
var requestedRecipient = null;
var paymentRouteSequence = 0;
var receiveQrMode = 'web';
function readBalancePrivacy() {
  try { return localStorage.getItem(balancePrivacyKey) === '1'; } catch (_) { return false; }
}
function privateAmount(sats) {
  return balancesHidden ? '••••••' : mintoFormat.coins(MintoWalletCore.formatSatoshis(sats));
}
function renderBalancePrivacy() {
  const label = getText(balancesHidden ? 'wallet_show_balances' : 'wallet_hide_balances');
  $('#wallet-balance-visibility').attr({'aria-label':label, title:label, 'aria-pressed':String(balancesHidden)});
  $('#wallet-balance-visibility .wallet-eye-slash').toggleClass('d-none', !balancesHidden);
  renderBalance();
  if (latestSnapshot && balanceState.sats !== null) renderBalanceFacts(latestSnapshot);
}
function renderBalanceFacts(result) {
  $('#wallet-total').text(privateAmount(result.available_sats + result.immature_sats + result.pending_sats) + ' NITO');
  $('#wallet-immature').text(privateAmount(result.immature_sats) + ' NITO');
  $('#wallet-pending').text(privateAmount(result.pending_sats) + ' NITO');
  renderMaturity(result);
}
function manualFee() {
  const value = $('#send-fee').val().trim();
  return !value || value === automaticFeeValue ? null : MintoWalletCore.toSatoshis(value);
}
function paymentError(error) {
  let message = messages.error[error.message] || getText(error.message);
  if (Number.isSafeInteger(error.maximum)) {
    message += '. ' + getText('wallet_sendable_total') + ': ' + privateAmount(error.maximum) + ' NITO.';
    if (latestSnapshot?.immature_sats) message += ' ' + getText('wallet_immature') + ': ' + privateAmount(latestSnapshot.immature_sats) + ' NITO.';
    if (latestSnapshot?.pending_sats) message += ' ' + getText('wallet_pending') + ': ' + privateAmount(latestSnapshot.pending_sats) + ' NITO.';
  }
  return message;
}
var generatedEmailPassword = null;
var rpcUrl = '/includes/rpc_proxy.php';
async function rpcCall(method, params = []) {
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 35000);
  try {
    const response = await fetch(rpcUrl, {
      method: 'POST', credentials: 'same-origin', cache: 'no-store', signal: controller.signal,
      headers: { 'Content-Type': 'application/json', 'X-Wallet-CSRF': window.walletConfig.csrf },
      body: JSON.stringify({ jsonrpc: '1.0', id: 'wallet', method, params })
    });
    const data = await response.json();
    if (!response.ok || data.error) {
      const error = new Error(getText([-25, -26, -27].includes(data.error?.code) ? 'wallet_node_rejected' : 'wallet_request_failed'));
      error.code = data.error?.code;
      if (data.error?.code === -32010) error.message = getText(data.error.message);
      else if ([-22,-25,-26,-27].includes(data.error?.code) && typeof data.error?.message === 'string') error.message += ': ' + data.error.message.slice(0,180);
      else if (response.status === 429) error.message = getText('wallet_retry_busy');
      throw error;
    }
    if (!Object.prototype.hasOwnProperty.call(data, 'result')) throw new Error(getText('wallet_request_failed'));
    return data.result;
  } catch (error) {
    if (error.name === 'AbortError') throw new Error(getText('wallet_request_failed'));
    throw error;
  } finally { clearTimeout(timeout); }
}

// ----- GESTION DE LA WEBCAM ET DU SCAN QR CODE -----
var stream = undefined;
var cameraEpoch = 0;
var cameraFrame = null;
var scannerLoading = null;

function loadScanner() {
  if (typeof jsQR === 'function') return Promise.resolve();
  if (!scannerLoading) scannerLoading = new Promise((resolve, reject) => {
    const source = document.getElementById('wallet-scanner-loader').content.querySelector('script');
    const script = document.createElement('script');
    script.src = source.src;
    script.integrity = source.integrity;
    script.nonce = source.nonce;
    script.onload = resolve;
    script.onerror = () => { script.remove(); scannerLoading = null; reject(new Error(getText('wallet_request_failed'))); };
    document.head.appendChild(script);
  });
  return scannerLoading;
}

function scanError(key) {
  $('#loading-message').addClass('d-none');
  $('#scan-canvas').prop('hidden', true);
  $('#scan-error').text(getText(key)).removeClass('d-none');
}
async function showScanModal() {
  stopStream();
  $('#scan-error').empty().addClass('d-none');
  $('#scan-canvas').prop('hidden', true);
  $('#loading-message').text(getText('webcam-loading')).removeClass('d-none');
  $('#scan-modal').modal('show');
  const epoch = cameraEpoch;
  if (!navigator.mediaDevices?.getUserMedia) { scanError('wallet_camera_missing'); return; }
  try {
    await loadScanner();
    if (epoch === cameraEpoch && $('#scan-modal').hasClass('show')) await startStream();
  } catch (_) { if (epoch === cameraEpoch) scanError('webcam-error'); }
}
async function startStream() {
  const epoch = cameraEpoch;
  const canvasElement = document.getElementById('scan-canvas');
  const canvas = canvasElement.getContext('2d');
  const video = document.createElement('video');
  try {
    const localStream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: 'environment' }, audio: false });
    if (epoch !== cameraEpoch) { localStream.getTracks().forEach(track => track.stop()); return; }
    stream = localStream;
    video.srcObject = stream;
    video.setAttribute('playsinline', '');
    video.muted = true;
    await video.play();
    if (epoch !== cameraEpoch) return;
    cameraFrame = requestAnimationFrame(tick);
  } catch (error) {
    if (epoch !== cameraEpoch) return;
    stopStream();
    const key = ['NotAllowedError','SecurityError'].includes(error.name) ? 'wallet_camera_denied'
      : ['NotFoundError','DevicesNotFoundError','OverconstrainedError'].includes(error.name) ? 'wallet_camera_missing' : 'webcam-error';
    scanError(key);
  }
  function tick() {
    if (epoch !== cameraEpoch || !stream) return;
    try {
      if (video.readyState >= video.HAVE_ENOUGH_DATA) {
        $('#loading-message').addClass('d-none');
        canvasElement.hidden = false;
        canvasElement.height = video.videoHeight;
        canvasElement.width = video.videoWidth;
        canvas.drawImage(video, 0, 0, canvasElement.width, canvasElement.height);
        const image = canvas.getImageData(0, 0, canvasElement.width, canvasElement.height);
        const code = jsQR(image.data, image.width, image.height, { inversionAttempts: 'dontInvert' });
        if (code) {
          let address;
          try { address = MintoWalletCore.paymentAddress(bitcoin, getConfig().network, code.data); }
          catch (_) { stopStream(); scanError('not-valid-address'); return; }
          let input = $('#send-outputs [name="send-address"]').filter(function() { return !this.value.trim(); }).first();
          if (!input.length) {
            if ($('#send-outputs .send-outputs-item').length >= 50) { stopStream(); scanError('wallet_recipient_limit'); return; }
            $('#add-output').trigger('click');
            input = $('#send-outputs [name="send-address"]').last();
          }
          input.val(address).trigger('focus');
          $('#scan-modal').modal('hide');
          stopStream();
          return;
        }
      }
      cameraFrame = requestAnimationFrame(tick);
    } catch (_) { stopStream(); scanError('webcam-error'); }
  }
}

function stopStream() {
  cameraEpoch++;
  if (cameraFrame !== null) cancelAnimationFrame(cameraFrame);
  cameraFrame = null;
  if (stream && stream.getTracks) {
    stream.getTracks().forEach(function(track) {
      if (track.readyState === 'live') {
        track.stop();
      }
    });
  }
  stream = undefined;
}

// --------------------------------------------------

/**
 * scanUTXO : scanne la blockchain pour trouver les UTXOs correspondant à la pubkey
 */
function scanWallet(address) {
  return rpcCall('walletsnapshot', [address])
    .then(result => {
      if (!result || result.success !== true || !Array.isArray(result.unspents)) throw new Error(getText('wallet_balance_unavailable'));
      return result;
    });
}


var balanceState = { sats: null, updatedAt: null, fresh: false, failures: 0 };
function setBalanceStatus(key) {
  $('.wallet-sync-text').text(getText(key));
  $('.wallet-sync').attr('data-state', key === 'wallet_balance_current' ? 'current' : 'waiting');
  const usable = balanceState.fresh && balanceState.sats !== null && !preparingPayment && !sending;
  $('#send-tx, .send-max').prop('disabled', !usable);
}
function renderBalance() {
  let sendable = null;
  if (balanceState.sats !== null && latestSnapshot) {
    try {
      const count = Math.max(1, [...document.querySelectorAll('#send-outputs .send-outputs-item')].filter(row => row.querySelector('[name="send-amount"]').value.trim()).length);
      const fee = manualFee() ?? (latestSnapshot.unspents.length ? MintoWalletCore.paymentFee(latestSnapshot.unspents.length, count, latestSnapshot.fee_rate) : 0);
      sendable = Math.max(0, balanceState.sats - fee);
    } catch (_) { /* An invalid manual fee must not be presented as an exact maximum. */ }
  }
  const amount = balancesHidden ? '••••••' : sendable === null ? '—' : mintoFormat.coins(MintoWalletCore.formatSatoshis(sendable));
  $('.wallet-balance .amount').each(function() { if (this.textContent !== amount) this.textContent = amount; });
  $('.wallet-balance .ticker').each(function() { if (this.textContent !== getConfig().ticker) this.textContent = getConfig().ticker; });
}
function renderMaturity(result) {
  const groups = Array.isArray(result.maturity_schedule) ? result.maturity_schedule : [];
  const list = $('#wallet-maturity-progress');
  // Rebuild only on a new chain state, never on each background poll.
  const state = JSON.stringify(groups) + ':' + Math.floor(result.updated_at / 60) + ':' + balancesHidden;
  if (list.attr('data-state') === state) return;
  list.attr('data-state',state).empty();
  let extra = null;
  groups.forEach((group,index) => {
    if (!Number.isInteger(group.confirmations) || group.confirmations < 1 || group.confirmations >= 100) return;
    if (index === 3) {
      extra = $('<details>').addClass('wallet-unlock-extra').appendTo(list);
      $('<summary>').text(getText('wallet_unlock_more').replace('{count}',String(groups.length-3))).appendTo(extra);
    }
    const item = $('<div>').addClass('wallet-unlock-item').appendTo(extra || list);
    const amount = privateAmount(group.amount_sats) + ' NITO';
    if (groups.length > 1) $('<strong>').text(amount).appendTo(item);
    $('<progress>').attr({max:100,value:group.confirmations,'aria-label':amount + ' — ' + getText('wallet_unlocking')}).appendTo(item);
    $('<span>').text(getText('wallet_unlock_progress').replace('{confirmations}',String(group.confirmations))).appendTo(item);
    const eta = new Date((result.updated_at + group.remaining_blocks * result.target_block_seconds) * 1000);
    $('<time>').attr('datetime',eta.toISOString()).text(getText('wallet_unlock_estimate').replace('{time}',mintoFormat.dateTime(eta))).appendTo(item);
  });
}
function walletBalance() {
  if (!globalData.keys || !globalData.address) return Promise.resolve(null);
  if (balancePending === walletEpoch) return balanceRequest;
  const epoch = walletEpoch;
  const address = globalData.address;
  balancePending = epoch;
  // Retain the last verified figure throughout a background request.
  if (balanceState.sats === null) setBalanceStatus('wallet_balance_refresh');
  $('.wallet-refresh').prop('disabled', true);
  balanceRequest = scanWallet(address).then(result => {
    if (epoch !== walletEpoch) return;
    let sats = 0;
    const seen = new Set();
    for (const u of result.unspents) {
      const id = u.txid + ':' + u.vout;
      if (seen.has(id)) throw new Error(getText('wallet_balance_unavailable'));
      seen.add(id);
      sats += MintoWalletCore.toSatoshis(typeof u.amount === 'number' ? u.amount.toFixed(8) : u.amount, true);
      if (!Number.isSafeInteger(sats)) throw new Error(getText('wallet_balance_unavailable'));
    }
    if (sats !== result.available_sats) throw new Error(getText('wallet_balance_unavailable'));
    if (!Number.isSafeInteger(result.fee_rate) || result.fee_rate < 0) throw new Error(getText('wallet_balance_unavailable'));
    latestSnapshot = result;
    balanceState = { sats, updatedAt: Date.now(), fresh: true, failures: 0 };
    globalData.balance = sats / 1e8;
    renderBalance();
    renderBalanceFacts(result);
    $('#wallet-pending-time').text(result.pending_sats > 0 ? getText('wallet_pending_eta') : '').prop('hidden', result.pending_sats <= 0);
    const time = new Date(balanceState.updatedAt);
    $('#wallet-updated').text(mintoFormat.time(time)).attr('datetime', time.toISOString());
    setBalanceStatus('wallet_balance_current');
    return result;
  }).catch(() => {
    if (epoch !== walletEpoch) return;
    balanceState.fresh = false;
    balanceState.failures++;
    setBalanceStatus(balanceState.sats === null ? 'wallet_balance_unavailable' : 'wallet_balance_stale');
  }).finally(() => {
    if (balancePending === epoch) {
      balancePending = null;
      $('.wallet-refresh').prop('disabled', false);
    }
  });
  return balanceRequest;
}

/**
 * Conversion NITO <-> sat
 */
function amountFormat(amount, invert = false) {
  const decimals = getConfig()['decimals'];

  if (!invert) {
    // NITO => affichage
    const valFloat = parseFloat(amount) || 0;
    const display = valFloat.toFixed(decimals);

    return parseFloat(display);
  } else {
    // NITO => sat
    const valFloat = parseFloat(amount) || 0;
    const converted = valFloat * Math.pow(10, decimals);

    return Math.round(converted);
  }
}

/************************************************
 *         Configuration du réseau (Nito)
 ************************************************/
var walletTimer = false;
var walletVersion = '1';

var networkConfigs = {
  'NITO': {
    'uri': 'nito:',
    'title': 'Nito Wallet',
    'name': getText('wallet_main_network'),
    'ticker': 'NITO',
    'decimals': 8,
    'fee': 0.00001,
    'network': {
      'messagePrefix': '\x19Minto.day Signed Message:\n',
      'bip32': {
        'public': 0x0488b21e,
        'private': 0x0488ade4
      },
      'bech32': 'nito',
      'pubKeyHash': 0x00,
      'scriptHash': 0x05,
      'wif': 0x80
    }
  }
};

// Explorateurs
var blockExplorer = {
  address: function(address) {
    return '/' + document.documentElement.lang + '/explorer/address/' + encodeURIComponent(address);
  },
  tx: function(tx) {
    return '/' + document.documentElement.lang + '/explorer/transaction/' + encodeURIComponent(tx);
  }
};

// Données globales
var globalData = {
  balance: 0,
  keys: undefined,
  address: undefined,
  rfee: getConfig()['fee'],
  tx: {
    amount: 0,
    outputs: [],
    fee: 0
  },
  resetTx: function() {
    this.tx = { amount: 0, outputs: [], fee: 0 };
  },
  clear: function() {
    this.keys = undefined;
    this.address = '';
    this.balance = 0;
    this.resetTx();
  }
};

// Récup texte localisé
function getText(token) {
  if (typeof window.lang_strings === 'undefined') {
    return token;
  }
  if (token in window.lang_strings) {
    return window.lang_strings[token];
  }
  return token;
}

var messages = initMessages();
function initMessages() {
  return {
    'settings': {
      'typeSwitched': function(type) {
        return getText('address-type-changed') + ' <b>' + type + '</b>';
      }
    },
    'error': {
      'bad-utxo': getText('bad-utxo'),
      'not-enough-funds': getText('not-enough-funds'),
      'not-valid-address': getText('not-valid-address'),
      'not-valid-amount': getText('not-valid-amount'),
      'not-valid-fee': getText('not-valid-fee'),
      'bad-priv-key': getText('bad-priv-key'),
      'not-enough-utxo': getText('not-enough-utxo'),
      'broadcast-failed': getText('broadcast-failed'),
      'pass-not-match': getText('pass-not-match'),
      'pass-too-short': getText('pass-too-short'),
      'bad-email': getText('bad-email'),
      'small-fee': getText('small-fee') + ' ' + getConfig()['fee'] + ' ' + getConfig()['ticker'] + '!'
    },
    'tx': {
      'loading-utxo': getText('loading-utxo'),
      'generating': getText('transaction-creation'),
      'success': getText('transaction-broadcasted')
    },
    'title': {
      'sure': getText('send-sure'),
      'processing': getText('send-processing'),
      'success': getText('success'),
      'failed': getText('failed')
    },
    'misc': {
      'outputAdded': function(address) {
        return getText('address') + ' ' + address + ' ' + getText('outputs-added');
      }
    }
  };
}

function initLang() {
  $("[tkey]").each(function() {
    var key = $(this).attr('tkey');
    if (['INPUT', 'TEXTAREA'].indexOf($(this).prop('tagName')) >= 0) {
      $(this).attr('placeholder', getText(key));
    } else {
      $(this).text(getText(key));
    }
  });
  messages = initMessages();
  setTitle(getText('wallet-settings'));
}

function getConfig() {
  var net = readCookie('network');
  if (!Object.prototype.hasOwnProperty.call(networkConfigs, net)) {
    setCookie('network', Object.keys(networkConfigs)[0], 60);
    net = Object.keys(networkConfigs)[0];
  }
  return networkConfigs[net];
}

function getAddressType() {
  var type = readCookie('type');
  if (!type || !['bech32'].includes(type)) {
    setCookie('type', 'bech32', 60);
    type = 'bech32';
  }
  return type;
}

function switchAddressType(type) {
  if (['bech32'].includes(type)) {
    setCookie('type', type, 60);
  }
}

function setCookie(name, value, days) {
  var expires = '';
  if (days) {
    var d = new Date();
    d.setTime(d.getTime() + days*24*60*60*1000);
    expires = '; expires=' + d.toUTCString();
  }
  document.cookie = encodeURIComponent(name) + '=' + encodeURIComponent(value) + expires + '; path=/; Secure; SameSite=Lax';
}

function readCookie(name) {
  var nameEQ = encodeURIComponent(name) + '=';
  var ca = document.cookie.split(';');
  for (var i=0; i<ca.length; i++) {
    var c = ca[i].trim();
    if (c.indexOf(nameEQ) === 0) {
      try { return decodeURIComponent(c.substring(nameEQ.length, c.length)); } catch (_) { return null; }
    }
  }
  return null;
}

function deleteCookie(name) {
  document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/';
}

function setTitle(title) {
  document.title = title + ' | ' + getConfig()['title'];
}

function routePage() {
  var urlParams = readParams();
  window.mintoPageMeta(walletRouteURL(urlParams[1],urlParams.slice(2)),urlParams[1]!=='send');
  if (location.hash.startsWith('#/')) history.replaceState(null, '', walletRouteURL(urlParams[1], urlParams.slice(2)));
  document.querySelectorAll('#dropdownContentModal a').forEach(link => {
    const locale = new URL(link.href).pathname.split('/')[1];
    link.href = walletRouteURL(urlParams[1], urlParams.slice(2)).replace(/^\/[^/]+/, '/' + locale);
  });
  if (urlParams[0] === '#') {
    var pageName = ['homepage', 'create', 'broadcast'].includes(urlParams[1]) ? urlParams[1] : 'homepage';
    var templateName = '#' + pageName;

    document.documentElement.dataset.walletRoute = pageName;
    $('.router-link').removeClass('active').removeAttr('aria-current');
    $('.router-link[data-route="' + pageName + '"]').addClass('active').attr('aria-current', 'page');

    $('div.router-page').hide();
    if ($(templateName).length) {
      $(templateName).show();
    }

    switch (pageName) {
      case 'homepage':
        setHomeTitle();
        break;
      case 'create':
        setTitle(getText('create-wallet'));
        break;
      case 'broadcast':
        setTitle(getText('broadcast-transaction'));
        break;
      default:
        switchPage('homepage');
        break;
    }
    if (urlParams[1] === 'send') readPaymentRequest();
  }
}

async function readPaymentRequest() {
  const route = readParams().join('/'), sequence = ++paymentRouteSequence;
  requestedRecipient = null;
  $('#wallet-payment-request').prop('hidden', true);
  try {
    if (!/^#\/send\/[a-zA-Z0-9]{14,90}$/.test(route)) throw new Error('not-valid-address');
    await loadWalletAsset('wallet-bitcoin-loader');
    if (sequence !== paymentRouteSequence || route !== readParams().join('/')) return;
    requestedRecipient = MintoWalletCore.paymentAddress(bitcoin, getConfig().network, route.slice('#/send/'.length));
    $('#wallet-request-address').text(requestedRecipient);
    $('#wallet-payment-request').prop('hidden', false);
    applyPaymentRequest();
  } catch (error) {
    if (sequence === paymentRouteSequence && route === readParams().join('/')) showMessage(getText(error.message));
  }
}

function applyPaymentRequest() {
  if (!requestedRecipient || !globalData.keys || preparingPayment || sending || preparedPayment || pendingBroadcast) return;
  // Preserve any drafted recipients and amounts. A link never initiates a payment.
  let input = $('#send-outputs [name="send-address"]').filter(function() { return this.value.trim().toLowerCase() === requestedRecipient; }).first();
  if (!input.length) input = $('#send-outputs [name="send-address"]').filter(function() { return !this.value.trim() && !$(this).closest('.send-outputs-item').find('[name="send-amount"]').val().trim(); }).first();
  if (!input.length) {
    if ($('#send-outputs .send-outputs-item').length >= 50) { showMessage(getText('wallet_recipient_limit')); return; }
    $('#add-output').trigger('click');
    input = $('#send-outputs [name="send-address"]').last();
  }
  input.val(requestedRecipient);
  requestedRecipient = null;
  $('#wallet-payment-request').prop('hidden', true);
  if (readParams()[1] === 'send') { history.replaceState(null, '', walletRouteURL('homepage')); routePage(); }
  $('[data-tab-name="wallet-send"]').trigger('click');
  input.closest('.send-outputs-item').find('[name="send-amount"]').trigger('focus');
}

function walletRouteURL(page = 'homepage', params = []) {
  const base = '/' + document.documentElement.lang + '/wallet';
  if (page === 'send' && params.length === 1) return base + '/send/' + encodeURIComponent(params[0]);
  return ['create','broadcast'].includes(page) ? base + '/' + page : base;
}
function readParams() {
  if (location.hash.startsWith('#/')) return location.hash.split('/');
  const parts = location.pathname.split('/').slice(3);
  return ['#', parts[0] || 'homepage', ...parts.slice(1)];
}
function switchPage(url = '', params = []) {
  const next = walletRouteURL(url, params);
  if (location.pathname + location.search + location.hash !== next) history.pushState(null, '', next);
  routePage();
}

function displayNetworks() {
  var net = getConfig();
  $('#network-versions').text(net['name']);
  $('#network-list .dropdown-menu').empty();

  for (var k in networkConfigs) {
    $('#network-list .dropdown-menu').append(`
      <a class="dropdown-item ${networkConfigs[k]['name'] === net['name'] ? 'active' : ''}"
         href="#/network/${k}">
         ${networkConfigs[k]['name']}
      </a>
    `);
  }
}

function switchConfig(network, page = '') {
  network = network.toUpperCase();
  if (networkConfigs[network] && networkConfigs[network] !== getConfig()) {
    setCookie('network', network, 60);
    closeWallet();
    displayNetworks();
  }
  switchPage(page);
}

/**
 * Affichage d'un message d'erreur ou d'info
 */
var messageTimer = null;
function showMessage(msg) {
  clearTimeout(messageTimer);
  $('#error-message-text').text(msg);
  $('#error-message').removeClass('d-none');
  messageTimer = setTimeout(() => $('#error-message').addClass('d-none'), 12000);
}

/**
 * Génère un QR code
 */
function showQrAddress(text) {
  $('#qr-code-addres').empty();
  // Version 8 has 49 modules: 196 px keeps each module exactly 4 px wide.
  $('#qr-code-addres').qrcode({text, width:196, height:196, typeNumber:8, correctLevel:0});
}
function renderReceiveQr() {
  if (!globalData.address || !globalData.keys) return;
  const text = receiveQrMode === 'web'
    ? MintoWalletCore.paymentLink(bitcoin, getConfig().network, globalData.address, document.documentElement.lang)
    : getConfig().uri + globalData.address;
  showQrAddress(text);
  $('[data-qr-mode]').each(function() { $(this).attr('aria-pressed', String(this.dataset.qrMode === receiveQrMode)); });
}

/**
 * Titre de la home
 */
function setHomeTitle() {
  if (globalData.keys) {
    setTitle(getText('address') + ' ' + globalData.address);
  } else {
    setTitle(getText('open-wallet'));
  }
}

function checkBalanceLoop() {
  clearTimeout(walletTimer);
  walletTimer = setTimeout(function() {
    if (!document.hidden) walletBalance();
    checkBalanceLoop();
  }, 10000);
}

function openWallet(keys) {
  walletEpoch++;
  globalData.keys = keys;
  globalData.balance = null;
  balanceState = { sats: null, updatedAt: null, fresh: false, failures: 0 };
  balancePending = null;
  renderBalance();
  $('#wallet-total, #wallet-updated, #wallet-immature, #wallet-pending').text('—');
  $('#wallet-pending-time').empty().prop('hidden', true);
  preparedPayment = null;
  $('#wallet-maturity-progress').empty().removeAttr('data-state');
  $('#wallet-updated').removeAttr('datetime');
  globalData.address = getAddress(keys);
  let pubkey = keys.publicKey.toString('hex');
  let wif = keys.toWIF();
  let p2wpkh = getP2WPKHScript(keys.publicKey);
  let redeem = '0014' + p2wpkh.hash.toString('hex');

  $('#wallet-keys-pubkey input').val(pubkey);
  $('#wallet-keys-privkey input').val(wif);
  $('#wallet-keys-script input').val(redeem);

  $('#wallet-address').val(globalData.address);
  renderContacts();
  $('#open-block').addClass('d-none');
  $('#wallet-block').removeClass('d-none');
  $('#history-link, #wallet-explorer-link').attr('href', blockExplorer.address(globalData.address));

  latestSnapshot = null;
  automaticFeeValue = '';
  $('#send-fee').attr('placeholder', getText('wallet_fee_auto'));

  receiveQrMode = 'web';
  renderReceiveQr();
  walletBalance();
  checkBalanceLoop();
  setHomeTitle();
  applyPaymentRequest();
}

function getScriptType(script) {
  if (script[0] === bitcoin.opcodes.OP_0 && script[1] === 20) {
    return 'bech32';
  }
  return undefined;
}

function getP2WPKHScript(pubkey) {
  return bitcoin.payments.p2wpkh({
    pubkey: pubkey,
    network: getConfig()['network']
  });
}

function getAddress(keys) {
  let net = getConfig()['network'];
  return bitcoin.payments.p2wpkh({
    pubkey: keys.publicKey,
    network: net
  }).address;
}

function validateAddress(addr) {
  return MintoWalletCore.validAddress(bitcoin, getConfig().network, addr);
}

function resetTxForm() {
  $('.send-additional-output').remove();
  $('#wallet-send input[name="send-address"]').val('');
  $('#wallet-send input[name="send-amount"]').val('');
  $('#wallet-send #send-fee').val('');
  automaticFeeValue = '';
  globalData.resetTx();
  renderBalance();
}

function generateEmailPassword() {
  walletEpoch++;
  generatedEmailPassword = null;
  $('#open-password, #open-password-confirm').val('');
  $('#legacy-ack').prop('checked', false);
  $('#open-password').attr('type', 'password');
  $('#email-password-show').attr('aria-pressed', 'false').text(getText('show'));
  try {
    generatedEmailPassword = MintoWalletCore.createEmailPassword(window.crypto, window.isSecureContext);
    $('#open-password').val(generatedEmailPassword);
  } catch (error) { showMessage(getText('wallet_secure_context')); }
}

function setEmailMode(create) {
  walletEpoch++; // Cancel any opening still waiting for the crypto libraries.
  generatedEmailPassword = null;
  $('#open-password, #open-password-confirm').val('');
  $('#open-password').prop('readOnly', create).attr({ type: 'password', autocomplete: create ? 'new-password' : 'current-password' });
  $('#email-password-tools, #email-password-help').toggleClass('d-none', !create);
  $('#open-password-confirm').attr('autocomplete', create ? 'off' : 'current-password');
  $('#legacy-ack').prop('checked', false);
  $('#open-regular-wallet').text(getText(create ? 'wallet_email_create' : 'open'));
  if (create) generateEmailPassword();
}

function closeWallet() {
  pendingBroadcast = null;
  preparedPayment = null;
  walletEpoch++;
  clearTimeout(walletTimer);
  stopStream();
  if (globalData.keys?.privateKey) globalData.keys.privateKey.fill(0);
  globalData.clear();
  $('#wallet-keys input, #create-keys input, #passphrase, #open-email, #open-password, #open-password-confirm, #transaction-broadcast-raw').val('');
  $('.keys-privkey').attr('type', 'password');
  $('.toggle-priv-key').text(getText('show'));
  $('#legacy-ack').prop('checked', false);
  $('input[name="email-mode"][value="open"]').prop('checked', true);
  setEmailMode(false);
  $('#wallet-address').val('');
  $('#qr-code-addres, #confirm-details').empty();
  balanceState = { sats: null, updatedAt: null, fresh: false, failures: 0 };
  renderBalance();
  $('#error-message').addClass('d-none');
  $('#contacts-form')[0]?.reset();
  resetTxForm();
  $('#open-block').removeClass('d-none');
  $('#wallet-block').addClass('d-none');
  setHomeTitle();
}
window.addEventListener('pagehide', closeWallet);

/**
 * Construction + signature + envoi de la TX
 */
async function testPayment(hex) {
  const results = await rpcCall('testmempoolaccept', [[hex]]);
  const result = Array.isArray(results) ? results[0] : null;
  if (!result || result.allowed !== true) {
    const reason = typeof result?.['reject-reason'] === 'string' ? result['reject-reason'].slice(0,180) : getText('wallet_request_failed');
    const hint = /fee|feerate/i.test(reason) ? 'wallet_reject_fee' : /missing|spent|inputs/i.test(reason) ? 'wallet_reject_spent' : /dust/i.test(reason) ? 'wallet_reject_dust' : 'wallet_node_rejected';
    throw new Error(getText(hint) + ' (' + reason + ')');
  }
  return result;
}
async function preparePayment(outputs, fee) {
  if (preparingPayment || sending) return;
  preparingPayment = true;
  preparedPayment = null;
  const epoch = walletEpoch, keys = globalData.keys;
  const button = $('#send-tx'), label = button.text();
  button.prop('disabled', true).text(getText('wallet_checking_payment'));
  try {
    const snapshot = await walletBalance();
    if (!snapshot) throw new Error(getText('wallet_balance_unavailable'));
    if (epoch !== walletEpoch || globalData.keys !== keys) return;
    const automatic = fee === null;
    const plan = MintoWalletCore.planPayment(snapshot.unspents, outputs, snapshot.fee_rate, fee);
    fee = plan.fee;
    const feeText = MintoWalletCore.formatSatoshis(fee);
    automaticFeeValue = automatic ? feeText : '';
    $('#send-fee').val(feeText);
    renderBalance();
    const hex = MintoWalletCore.buildTransaction(bitcoin, getConfig().network, keys, outputs, fee, plan.utxos);
    const review = await testPayment(hex);
    if (epoch !== walletEpoch || globalData.keys !== keys) return;
    const txid = bitcoin.Transaction.fromHex(hex).getId();
    if (review.txid !== txid) throw new Error(getText('wallet_request_failed'));
    preparedPayment = { hex, txid, epoch };
    showConfirmation(outputs, fee);
  } catch (error) { if (epoch === walletEpoch) showMessage(paymentError(error)); }
  finally {
    preparingPayment = false;
    button.text(label);
    setBalanceStatus(balanceState.fresh ? 'wallet_balance_current' : (balanceState.sats === null ? 'wallet_balance_unavailable' : 'wallet_balance_stale'));
  }
}
async function sendTransaction() {
  if (sending || !preparedPayment || preparedPayment.epoch !== walletEpoch) return;
  const payment = preparedPayment;
  sending = true;
  $('#send-confirm, #send-cancel, #footer-broadcast').prop('disabled', true);
  $('#confirm-screen').addClass('d-none');
  $('#status-screen').removeClass('d-none');
  $('#status-screen .extra-info').empty();
  $('#status-screen span').text(messages.tx.generating);
  $('#send-title').text(messages.title.processing);
  try {
    // Re-check after review, then broadcast only following the explicit confirmation.
    await testPayment(payment.hex);
    if (payment.epoch !== walletEpoch) throw new Error(getText('wallet_session_changed'));
    const txid = await rpcCall('sendrawtransaction', [payment.hex]);
    if (!/^[a-f0-9]{64}$/i.test(txid) || txid !== payment.txid) throw new Error(getText('wallet_request_failed'));
    $('#status-screen span').text(messages.tx.success + ' ');
    $('<a>').attr({ href: blockExplorer.tx(txid), target: '_blank', rel: 'noopener noreferrer' }).text(txid).appendTo('#status-screen span');
    $('#send-title').text(messages.title.success);
    resetTxForm();
    balanceState.fresh = false;
    setBalanceStatus('wallet_balance_refresh');
    walletBalance();
  } catch (error) {
    $('#send-title').text(messages.title.failed);
    $('#status-screen span').text(messages.error['broadcast-failed']);
    $('#status-screen .extra-info').text(messages.error[error.message] || error.message || getText('wallet_request_failed'));
    walletBalance();
  } finally {
    preparedPayment = null;
    sending = false;
    $('#send-confirm').addClass('d-none').prop('disabled', true);
    $('#send-cancel, #footer-broadcast').prop('disabled', false);
    $('#send-close-footer').removeClass('disabled d-none');
  }
}

/**
 * showConfirmation : prépare la TX avant envoi
 */
function showConfirmation(outputs, fee) {
  pendingBroadcast = null;
  $('.confirm-summary').show();
  globalData.tx.outputs = outputs.map(o => ({ ...o }));
  globalData.tx.amount = outputs.reduce((sum, o) => sum + o.amount, 0);
  globalData.tx.fee = fee;
  $('#confirm-amount').text(mintoFormat.coins(MintoWalletCore.formatSatoshis(globalData.tx.amount + fee)) + ' NITO');
  const details = $('#confirm-details').empty();
  $('<strong>').text(getText('wallet_recipients')).appendTo(details);
  outputs.forEach(o => $('<div>').text(o.address + ' — ' + mintoFormat.coins(MintoWalletCore.formatSatoshis(o.amount)) + ' NITO').appendTo(details));
  $('<div>').text(getText('wallet_network_fee') + ': ' + mintoFormat.coins(MintoWalletCore.formatSatoshis(fee)) + ' NITO').appendTo(details);
  $('#send-modal').modal('show');
  $('#send-title').text(messages.title.sure);
  $('#confirm-screen').removeClass('d-none');
  $('#status-screen').addClass('d-none');
  $('#status-screen span, #status-screen .extra-info').empty();
  $('#send-confirm, #send-cancel').removeClass('disabled d-none').prop('disabled', false);
  $('#send-close-footer').addClass('disabled d-none');
}

/**
 * Si on a déjà globalData.keys => on ouvre direct
 */
function initWallet(){
    if(globalData.keys){
        openWallet(globalData.keys);
    }
}

// Public address book only: never store keys, passwords, balances or transactions.
const contactsStorageKey = 'minto.wallet.contacts.v1';
var walletContacts = [];
var contactsWritable = true;
var contactTarget = null;
var editingContact = null;
function renderContacts() {
  contactsWritable = true;
  try {
    const raw = localStorage.getItem(contactsStorageKey);
    const records = raw === null ? [] : JSON.parse(raw);
    if (!Array.isArray(records) || records.length > 100) throw new Error('invalid contacts');
    const seen = new Set();
    walletContacts = records.map(item => {
      if (!item || typeof item.name !== 'string' || !item.name.trim() || item.name.length > 60 || typeof item.address !== 'string' || !validateAddress(item.address)) throw new Error('invalid contact');
      const address = item.address.toLowerCase();
      if (seen.has(address)) throw new Error('duplicate contact');
      seen.add(address);
      return { name: item.name.trim(), address };
    });
  } catch (_) {
    walletContacts = [];
    contactsWritable = false;
    showMessage(getText('wallet_contacts_unavailable'));
  }
  const list = $('#contacts-list').empty();
  if (!walletContacts.length) $('<p>').addClass('wallet-subtle').text(getText('wallet_contacts_empty')).appendTo(list);
  walletContacts.forEach(contact => {
    const row = $('<div>').addClass('wallet-contact');
    const details = $('<div>').addClass('wallet-contact-info').appendTo(row);
    $('<strong>').text(contact.name).appendTo(details);
    $('<span>').attr('dir','ltr').text(contact.address).appendTo(details);
    const actions = $('<div>').addClass('wallet-contact-actions').appendTo(row);
    $('<button>').attr({type:'button','data-contact-use':contact.address}).addClass('btn btn-dark').text(getText('wallet_contact_use')).appendTo(actions);
    $('<button>').attr({type:'button','data-contact-edit':contact.address}).addClass('btn btn-dark').text(getText('wallet_contact_edit')).appendTo(actions);
    $('<button>').attr({type:'button','data-contact-delete':contact.address}).addClass('btn btn-outline-danger').text(getText('wallet_contact_delete')).appendTo(actions);
    row.appendTo(list);
  });
  $('#contacts-save').prop('disabled', !contactsWritable);
}
function saveContacts(contacts) {
  if (!contactsWritable) { showMessage(getText('wallet_contacts_unavailable')); return false; }
  try {
    localStorage.setItem(contactsStorageKey, JSON.stringify(contacts));
    renderContacts();
    return true;
  } catch (_) { showMessage(getText('wallet_contacts_unavailable')); return false; }
}
function initContacts() {
  $('#contacts-form').on('reset', () => { editingContact = null; });
  $('#contacts-form').on('submit', function(event) {
    event.preventDefault();
    const name = $('#contact-name').val().trim();
    const address = $('#contact-address').val().trim();
    if (!name || name.length > 60) { $('#contact-name')[0].reportValidity(); return; }
    if (!validateAddress(address)) { showMessage(getText('not-valid-address')); return; }
    const normalized = address.toLowerCase();
    if (editingContact && editingContact !== normalized && walletContacts.some(item => item.address === normalized)) { showMessage(getText('wallet_contact_exists')); return; }
    const list = walletContacts.filter(item => item.address !== normalized && item.address !== editingContact);
    if (list.length >= 100) { showMessage(getText('wallet_contacts_unavailable')); return; }
    list.push({name,address:normalized});
    list.sort((a,b) => a.name.localeCompare(b.name, document.documentElement.lang));
    if (saveContacts(list)) { this.reset(); showMessage(getText('wallet_contact_saved')); }
  });
  $('#contacts-list').on('click', '[data-contact-use]', function() {
    const address = $(this).attr('data-contact-use');
    if (!walletContacts.some(item => item.address === address) || !validateAddress(address)) return;
    let target = contactTarget?.isConnected ? $(contactTarget) : $('#send-outputs [name="send-address"]').filter(function(){return !this.value.trim()}).first();
    if (!target.length) {
      if ($('#send-outputs .send-outputs-item').length >= 50) { showMessage(getText('wallet_recipient_limit')); return; }
      $('#add-output').trigger('click');target = $('#send-outputs [name="send-address"]').last();
    }
    target.val(address);
    $('[data-tab-name="wallet-send"]').trigger('click');
    target.trigger('focus');
    contactTarget = null;
  });
  $('#contacts-list').on('click', '[data-contact-edit]', function() {
    const item = walletContacts.find(item => item.address === $(this).attr('data-contact-edit'));
    if (item) { editingContact = item.address; $('#contact-name').val(item.name); $('#contact-address').val(item.address); $('#contact-name').trigger('focus'); }
  });
  $('#contacts-list').on('click', '[data-contact-delete]', function() {
    const address = $(this).attr('data-contact-delete');
    saveContacts(walletContacts.filter(item => item.address !== address));
  });
  $('#send-outputs').on('click', '.recipient-contacts', function() {
    contactTarget = this.closest('.send-outputs-item').querySelector('[name="send-address"]');
    $('[data-tab-name="wallet-contacts"]').trigger('click');
    editingContact = null;
    $('#contact-name').val('');
    $('#contact-address').val(validateAddress(contactTarget.value.trim()) ? contactTarget.value.trim() : '');
    $('#contact-name').trigger('focus');
  });
  $('[data-tab-name="wallet-contacts"]').on('click', renderContacts);
  window.addEventListener('storage', event => { if (event.key === contactsStorageKey && globalData.keys) renderContacts(); });
}

// --------------------------------------------
//       DOCUMENT READY
// --------------------------------------------
$(document).ready(function() {

  $('#open-password, #open-password-confirm, #passphrase').attr('autocomplete', 'new-password');

  $('div.router-page').hide();
  initLang();

  $('#wallet-version').text(walletVersion);
  $('#address-type-select select').val(getAddressType());
  displayNetworks();
  renderBalancePrivacy();

  routePage();
  $(window).on('hashchange popstate', routePage);
  $(document).on('click', 'a[data-wallet-route]', function(event) {
    if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    event.preventDefault(); switchPage(this.dataset.walletRoute);
  });

  // Gérer les onglets
  $('.tab-link').click(function(e) {
    e.preventDefault();
    let tabFamily = $(this).data('tab-family');
    let tabName = $(this).data('tab-name');

    $('#' + tabFamily + ' .tab-item').addClass('d-none');
    $('#' + tabFamily + ' .card-header .card-header-tabs .nav-link').removeClass('active');

    $('#' + tabFamily + ' [data-tab="' + tabName + '"]').removeClass('d-none');
    $(this).addClass('active');
  });

  // Bouton "Envoyer" => préparation de la confirmation
  $('#send-tx').click(function() {
    try {
      if (preparingPayment || sending) return;
      const fee = manualFee();
      if (fee !== null && fee < 1000) throw new Error('small-fee');
      const outputs = [];
      $('#send-outputs .send-outputs-item').each(function(k, item) {
        const address = $('[name="send-address"]', item).val().trim();
        if (k > 0 && !address && !$('[name="send-amount"]', item).val().trim()) return;
        if (!validateAddress(address)) throw new Error('not-valid-address');
        const amount = MintoWalletCore.toSatoshis($('[name="send-amount"]', item).val());
        outputs.push({ address, amount });
      });
      const total = outputs.reduce((sum, o) => sum + o.amount, fee || 0);
      if (!outputs.length || outputs.length > 50 || !Number.isSafeInteger(total)) throw new Error('not-valid-amount');
      preparePayment(outputs, fee);
    } catch (error) { showMessage(messages.error[error.message] || getText(error.message)); }
  });

  // Ouverture par clé WIF
  $('#open-key-form').submit(function(e) {
    e.preventDefault();
    withWalletCrypto(document.getElementById('open-key-wallet'), false, () => {
    let wif = $('#passphrase').val().trim();
    let wifLength = wif.length;
    if ([51, 52].includes(wifLength)) {
      try {
        const keys = bitcoin.ECPair.fromWIF(wif, getConfig()['network']);
        if (!keys.compressed) throw new Error('bad-priv-key');
        globalData.keys = keys;
        $('#passphrase').val('');
        initWallet();
      } catch (e) {
        showMessage(messages.error['bad-priv-key']);

      }
    } else {
      showMessage(messages.error['bad-priv-key']);
    }
    });
  });

  // Ouverture par Email + pass
  $('input[name="email-mode"]').on('change', function() { setEmailMode(this.value === 'create'); });
  $('#email-password-generate').on('click', generateEmailPassword);
  $('#email-password-show').on('click', function() {
    const show = $('#open-password').attr('type') === 'password';
    $('#open-password').attr('type', show ? 'text' : 'password');
    $(this).attr('aria-pressed', String(show)).text(getText(show ? 'wallet_hide' : 'show'));
  });
  $('#open-email, #open-password, #open-password-confirm').on('input', function() {
    $('#legacy-ack').prop('checked', false);
  });
  $('#open-regular-form').submit(function(e) {
    e.preventDefault();
    withWalletCrypto(document.getElementById('open-regular-wallet'), true, () => {
    if (!$('#legacy-ack').is(':checked')) { showMessage(getText('wallet_legacy_ack')); return; }
    let email = $('#open-email').val().toLowerCase();
    let pass = $('#open-password').val();
    let passC = $('#open-password-confirm').val();
    const creating = $('input[name="email-mode"]:checked').val() === 'create';
    if (creating && (!generatedEmailPassword || pass !== generatedEmailPassword)) {
      showMessage(getText('wallet_email_help')); return;
    }

    if (email.match(/^[\w\d.+-]+@[\w\d.-]+\.[A-Za-z]{2,}$/)) {
      if (pass.length >= 10) {
        if (pass === passC) {
          let s = MintoWalletCore.deriveLegacyHex(email, pass, sha256);
          generatedEmailPassword = null;
          $('#open-email').val('');
          $('#open-password').val('');
          $('#open-password-confirm').val('');
          globalData.keys = bitcoin.ECPair.fromPrivateKey(
            bitcoin.Buffer.from(s, 'hex'),
            { network: getConfig()['network'] }
          );
          openWallet(globalData.keys);
        } else {
          showMessage(messages.error['pass-not-match']);
        }
      } else {
        showMessage(messages.error['pass-too-short']);
      }
    } else {
      showMessage(messages.error['bad-email']);
    }
    });
  });

  // Cliquer sur le solde pour recharger
  $('.wallet-refresh').click(function(e) {
    e.preventDefault();
    walletBalance();
  });

  $('#wallet-balance-visibility').on('click', function() {
    balancesHidden = !balancesHidden;
    try { localStorage.setItem(balancePrivacyKey, balancesHidden ? '1' : '0'); } catch (_) { /* This session still respects the choice. */ }
    $('#error-message').addClass('d-none');
    renderBalancePrivacy();
  });
  window.addEventListener('storage', event => {
    if (event.key === balancePrivacyKey || event.key === null) { balancesHidden = readBalancePrivacy(); renderBalancePrivacy(); }
  });
  $('[data-qr-mode]').on('click', function() { receiveQrMode = this.dataset.qrMode === 'native' ? 'native' : 'web'; renderReceiveQr(); });
  $('#wallet-request-cancel').on('click', function() {
    paymentRouteSequence++;
    requestedRecipient = null;
    $('#wallet-payment-request').prop('hidden', true);
    if (readParams()[1] === 'send') switchPage('homepage');
  });
  $('#wallet-copy-link').on('click', async function() {
    if (!globalData.address || !globalData.keys) return;
    const link = MintoWalletCore.paymentLink(bitcoin, getConfig().network, globalData.address, document.documentElement.lang);
    try {
      if (!navigator.clipboard?.writeText) throw new Error('unavailable');
      await navigator.clipboard.writeText(link);
      showMessage(getText('top_copied'));
    } catch (_) { showMessage(getText('wallet_request_failed')); }
  });

  $('#wallet-copy-address').on('click', async function() {
    const input = document.getElementById('wallet-address');
    try {
      if (!navigator.clipboard?.writeText) throw new Error('unavailable');
      await navigator.clipboard.writeText(input.value);
      showMessage(getText('top_copied'));
    } catch (_) {
      input.focus(); input.select();
      showMessage(getText('wallet_copy_manual'));
    }
  });
  $('#wallet-address').on('click', function() { this.select(); });
  $('#wallet-dismiss-message').on('click', () => { clearTimeout(messageTimer); $('#error-message').addClass('d-none'); });
  $('#send-outputs').on('click', '.send-max', async function() {
    try {
      if (!balanceState.fresh || balanceState.sats === null || Date.now() - balanceState.updatedAt > 5000) { if (!await walletBalance()) throw new Error('wallet_balance_unavailable'); }
      const row = this.closest('.send-outputs-item');
      const others = [...document.querySelectorAll('#send-outputs [name="send-amount"]')].filter(input => !row.contains(input)).map(input => input.value);
      let fee = manualFee();
      const automatic = fee === null;
      if (!latestSnapshot.unspents.length) { const error = new Error('not-enough-funds'); error.maximum = 0; throw error; }
      if (fee === null) fee = MintoWalletCore.paymentFee(latestSnapshot.unspents.length, 1 + others.filter(v => v.trim()).length, latestSnapshot.fee_rate);
      if (fee < 1000) throw new Error('small-fee');
      $(row).find('[name="send-amount"]').val(MintoWalletCore.maximumAmount(balanceState.sats, fee, others));
      const feeText = MintoWalletCore.formatSatoshis(fee);
      automaticFeeValue = automatic ? feeText : '';
      $('#send-fee').val(feeText);
      renderBalance();
    } catch (error) { showMessage(paymentError(error)); }
  });
  $('#send-fee').on('input', () => { automaticFeeValue = ''; renderBalance(); });
  $('#send-outputs').on('input', '[name="send-amount"]', renderBalance);
  document.addEventListener('visibilitychange', () => { if (!document.hidden && globalData.keys && (!balanceState.updatedAt || Date.now()-balanceState.updatedAt>3000)) walletBalance(); });
  initContacts();

  // Confirmer l'envoi
  $('#send-confirm').click(function(e) {
    e.preventDefault();
    if (pendingBroadcast) broadcastTransaction();
    else sendTransaction();
  });

  // Annuler l'envoi
  $('#send-cancel').click(function(e) {
    e.preventDefault();
    $('#send-modal').modal('hide');
  });

  // Toggle clé privée
  $('#wallet-area .toggle-priv-key').click(function() {
    let privKeyInput = $(this).closest('.wallet-form3').find('.keys-privkey');
    if (privKeyInput.attr('type') === 'password') {
      privKeyInput.attr('type', 'text');
      $(this).text(getText('wallet_hide'));
    } else {
      privKeyInput.attr('type', 'password');
      $(this).text(getText('show')).attr('tkey', 'show');
    }
  });

  $('#add-output').on('click', function(e) {
    e.preventDefault();
    if ($('#send-outputs .send-outputs-item').length >= 50) { showMessage(getText('wallet_recipient_limit')); return; }
    const row = $('#recipient-template')[0].content.firstElementChild.cloneNode(true);
    $('#send-outputs').append(row);
    $(row).find('.send-max').prop('disabled', !balanceState.fresh);
    $(row).find('[name="send-address"]').trigger('focus');
  });

  // Retirer un output
  $('#send-outputs').on('click', '.remove-additional-output', function(e) {
    e.preventDefault();
    $(this).closest('.send-additional-output').remove();
    renderBalance();
  });

  // Reset form envoi
  $('#send-reset').click(function(e) {
    e.preventDefault();
    resetTxForm();
  });

  // Scan QR
  $('#send-qr').click(function(e) {
    e.preventDefault();
    showScanModal();
  });

  // Fermer le wallet
  $('#footer-close').click(function(e) {
    e.preventDefault();
    closeWallet();
  });

  // Choisir type d'adresse
  $('#address-type-select select').on('change', function() {
    let sel = $(this).val();
    switchAddressType(sel);
    initWallet();
  });

  // Stop la webcam quand on ferme le modal
  $('#scan-modal').on('hide.bs.modal', function() {
    stopStream();
  });

  // Création d'un wallet
  $('#footer-create').click(function() {
    withWalletCrypto(this, false, () => {
    let keys;
    try { keys = MintoWalletCore.createRandomKey(bitcoin, getConfig().network, window.crypto, window.isSecureContext); }
    catch (error) { showMessage(getText(error.message)); return; }
    $('#create-keys-privkey input').attr('type', 'password');
    let addr = getAddress(keys);
    if (addr) {
      $('#create-keys-address input').val(addr);
      $('#create-keys-pubkey input').val(keys.publicKey.toString('hex'));
      $('#create-keys-privkey input').val(keys.toWIF());
      keys.privateKey.fill(0);
      showMessage(getText('wallet_created'));
    }
    });
  });

  // Diffusion manuelle
  $('#footer-broadcast').click(function() {
    if (sending) return;
    withWalletCrypto(this, false, () => {
    const rawtx = $('#transaction-broadcast-raw').val().trim();
    let tx;
    try { tx = MintoWalletCore.inspectTransaction(bitcoin, getConfig().network, rawtx); }
    catch (_) { showMessage(messages.error['broadcast-failed']); return; }
    const details = $('#confirm-details').empty();
    $('<p>').text(getText('wallet_raw_review')).appendTo(details);
    $('<div>').text(getText('wallet_txid') + ': ' + tx.id).appendTo(details);
    tx.outputs.forEach(output => {
      $('<div>').text((output.address.startsWith('Script: ') ? getText('wallet_script') + ': ' + output.address.slice(8) : output.address) + ' — ' + mintoFormat.coins(MintoWalletCore.formatSatoshis(output.amount)) + ' NITO').appendTo(details);
    });
    pendingBroadcast = rawtx;
    $('.confirm-summary').hide();
    $('#send-title').text(messages.title.sure);
    $('#confirm-screen').removeClass('d-none');
    $('#status-screen').addClass('d-none');
    $('#send-confirm, #send-cancel').removeClass('disabled d-none').prop('disabled', false);
    $('#send-close-footer').addClass('disabled d-none');
    $('#send-modal').modal('show');
    });
  });
  $('#send-modal').on('hidden.bs.modal', () => { if (!sending) { pendingBroadcast = null; preparedPayment = null; } });
  $('#send-modal').on('hide.bs.modal', event => { if (sending) event.preventDefault(); });

}); // Fin du $(document).ready
async function broadcastTransaction() {
  if (sending || !pendingBroadcast) return;
  const rawtx = pendingBroadcast;
  const expectedId = bitcoin.Transaction.fromHex(rawtx).getId();
  pendingBroadcast = null;
  sending = true;
  $('#send-confirm, #send-cancel, #send-close, #footer-broadcast').prop('disabled', true);
  $('#confirm-screen').addClass('d-none');
  $('#status-screen').removeClass('d-none');
  $('#status-screen .extra-info').empty();
  $('#status-screen span').text(messages.title.processing);
  $('#send-title').text(messages.title.processing);
  try {
    await testPayment(rawtx);
    const txid = await rpcCall('sendrawtransaction', [rawtx]);
    if (typeof txid !== 'string' || txid !== expectedId) throw new Error(getText('wallet_request_failed'));
    $('#send-title').text(messages.title.success);
    $('#status-screen span').text(messages.tx.success + ' ');
    $('<a>').attr({ href: blockExplorer.tx(txid), target: '_blank', rel: 'noopener noreferrer' }).text(txid).appendTo('#status-screen span');
    $('#transaction-broadcast-raw').val('');
  } catch (error) {
    $('#send-title').text(messages.title.failed);
    $('#status-screen span').text(messages.error['broadcast-failed']);
    $('#status-screen .extra-info').text(error.message);
  } finally {
    sending = false;
    $('#send-confirm, #send-cancel').addClass('d-none');
    $('#send-cancel, #send-close').prop('disabled', false);
    $('#send-close-footer').removeClass('disabled d-none');
    $('#footer-broadcast').prop('disabled', false);
  }
}
